import React from 'react';
import Helpers from './Helpers.js'

import './InfoBox.css';

class InfoBox extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			height: 0,
			width: 0,
			visibility: "none",
			stateInfo: null,
			staat: null
		}
	}

	render() {
		if(this.props.activeStateInfo !== "none" && this.props.activeStateInfo!==undefined) {
			return(
				<div className={'infoBox ib-'+this.props.activeStateInfo.id +' show-'+this.props.show}>
					<div className='infoBox-stateBoxInfo'>
						<h6>
							{this.props.activeStateInfo.name}
						</h6>{
							this.props.activeStateInfo.notes.length> 1
							? <div className='state-notes'><b>{this.props.activeStateInfo.notes}</b></div>
							: false
						}
						{
							this.props.activeStateInfo.polls.length>1 && this.props.show==="polls"
							? <div className={'polls polls-'+this.props.activeStateInfo.polls}><b>{this.props.data.polls[this.props.activeStateInfo.polls].label}</b></div>
							: false
						}						
						Elektoren: {this.props.activeStateInfo.electors} 
						{this.props.activeStateInfo.candidates.winner !== "none" && this.props.activeStateInfo.candidates.winner.length > 3
							? <div>Gewinner: <b className='winner'>{this.props.activeStateInfo.candidates.winner}</b></div>
							: false
						}
						{
							this.props.activeStateInfo.totals.votes*1 > 0
							? <div>Stimmen Total: {Helpers.tsnds(this.props.activeStateInfo.totals.votes)}</div>
							: false
						}
						{
							this.props.activeStateInfo.counted*1 > 0
							? <div className='counted'>{this.props.activeStateInfo.counted}% gezählt</div>
							: false
						}
					</div>
					<ol className='infoBox-candidates'>
						{
							Helpers.o2a(this.props.activeStateInfo.candidates.a).items.map((candidate,k_0) => {
								if(candidate.percent*1+candidate.votes*1+candidate.electors*1>0) {
									return(
										<li key = {k_0} className={''+this.props.data.parties.o[candidate.party].partycode}>
											<b className='candidate-name'>{candidate.name} ({this.props.data.parties.o[candidate.party].partycode})</b>
											<div className='infoBox-candidate-info'>
												<div className='votes-align'>
													{
														candidate.percent*1>0
															? <span>Stimmen: <b>{candidate.percent}%</b><br/></span>
															: false
														}
													
													{
														candidate.percent*1>0
															? Helpers.tsnds(candidate.votes)
															: false
													}	
												</div>
												{
													candidate.percent*1>0
														? <div className='fullbar'><div className='bar bar-votes' style = {{width:candidate.percent+'%' }}></div></div>
														: false
												}
							
											</div>
										</li>									
									)
								}
								else {
									return false
								}

							})
						}
					</ol>
				</div>
			)
		}
		else {
			return false
		}
	}
}

export default InfoBox
